import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { BootstrapModalService } from 'src/app/services/bootstrap-modal.service';
import { SweetAlertService } from 'src/app/services/sweetalert.service';
import { ResendEmailComponent } from '../resend-email/resend-email.component';

@Component({
  selector: 'app-check-email',
  templateUrl: './check-email.component.html',
  styleUrls: ['./check-email.component.scss']
})
export class CheckEmailComponent implements OnInit {

  verifying = true;
  success = false;
  errorMessage = '';
  currentYear = new Date().getFullYear();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private modalService: BootstrapModalService,
    private sweetAlertService: SweetAlertService
  ) { }

  ngOnInit(): void {
    const uid = this.route.snapshot.queryParamMap.get('uid');
    const token = this.route.snapshot.queryParamMap.get('token');

    if (!uid || !token) {
      this.handleVerificationError('Paramètres uid ou token manquants');
      return;
    }

    this.verifyEmail(uid, token);
  }

  verifyEmail(uid: string, token: string): void {
    const body = {
      uid: uid,
      token: token
    }

    this.authService.verifyEmail(body).subscribe({
      next: (response) => {
        this.verifying = false;
        this.success = true;

        this.sweetAlertService.toastSuccess(
          'Email vérifié avec succès !',
          3000
        );

        this.goToLogin();
      },
      error: (error: HttpErrorResponse) => {
        this.handleVerificationError(
          error.error?.message ||
          error.error?.error ||
          'Le lien de vérification est invalide ou a expiré'
        );
      }
    });
  }

  handleVerificationError(message: string): void {
    this.verifying = false;
    this.success = false;
    this.errorMessage = message;
  }

  goToLogin(): void {
    this.router.navigate(['/auth/signin']);
  }

  openResendVerificationModal(): void {
    this.modalService.openModal(ResendEmailComponent, '', 'modal-md');
  }

}
